import { makeStyles } from '@material-ui/core'
import { Grid } from '@mui/material'
import { NOT_COVERED_ITEMS } from 'src/utils/constants/BuyPolicy'
import { COLORS } from 'src/utils/Themes/colors'

const NotCoveredCoverages = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <span className={classes.title}>&apos;What&apos;s not Covered&apos;</span>
      <Grid container className={classes.gridContainer}>
        <>
          {NOT_COVERED_ITEMS?.map((notCoveredItem) => {
            return (
              <Grid
                item
                xs={12}
                md={4}
                lg={4}
                key={`notCoveredItem_${notCoveredItem.id}`}
                justifyContent='center'
                alignItems='stretch'
                className={classes.gridItem}
              >
                <div className={classes.notCoveredContainer}>
                  <div className={classes.notCoveredTitle}>
                    {notCoveredItem?.title}
                  </div>
                  <div className={classes.notCoveredDescription}>
                    {notCoveredItem?.description}
                  </div>
                </div>
              </Grid>
            )
          })}
        </>
      </Grid>
    </div>
  )
}
export default NotCoveredCoverages
const useStyles = makeStyles({
  container: {
    borderTop: '1px solid #E9E9E9',
    borderBottom: '1px solid #E9E9E9',
    padding: '20px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: '18px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'center',
    margin: '20px 0',
  },
  gridContainer: {
    marginBottom: '20px',
  },
  gridItem: {
    '@media (min-width:900px)': {
      borderRight: '1px solid #E0E0E0',
      '&:last-child': {
        borderRight: '0',
      },
    },
    '@media (max-width:899px)': {
      borderBottom: '1px solid #E0E0E0',
      '&:last-child': {
        borderBottom: '0',
      },
    },
  },
  notCoveredContainer: {
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    '@media (max-width:899px)': {
      padding: '20px 0',
    },
  },
  notCoveredTitle: {
    fontSize: '14px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
  },
  notCoveredDescription: {
    fontSize: '14px',
    color: '#484848',
  },
})
